<nb-card [nbSpinner]="isTransactionPending">
  <nb-card-header>
    <div class="row align-items-center">
      <div class="col-10 text-start">Buy tokens</div>
      <div class="col-2 d-flex text-end justify-content-end">
        <button nbButton size="small" status="danger" (click)="onClose()">
          CLOSE
        </button>
      </div>
    </div>
  </nb-card-header>
  <nb-card-body
    ><div class="col-12">
      <div class="row d-flex">
        <div class="col-4">
          <h6>Current rate</h6>
          <p>
            1 {{ contributionTokenSymbol }} = {{ 1 | number }}
            {{ tokenSymbol }}
          </p>
        </div>
        <div class="col-4">
          <h6>Min. contribution</h6>
          <p>{{ minContribution | number }}</p>
        </div>
        <div class="col-4">
          <h6>Max. contribution</h6>
          <p>{{ maxContribution | number }}</p>
        </div>
      </div>
      <div class="row mt-3" [formGroup]="contributeForm">
        <div class="col-4">
          <div class="input-wrapper">
            <label for="first"
              >You pay
              <span
                class="ml-2 max-btn"
                (click)="
                  contributeForm.controls.payValue.setValue(maxContribution);
                  updatePayoutValue()
                "
                >Max.</span
              ></label
            >
            <input
              type="number"
              formControlName="payValue"
              (input)="updatePayoutValue()"
            />
          </div>
        </div>
        <div
          class="col-1 d-flex flex-column justify-content-center align-items-top"
        >
          <!-- <img
            [src]="sanitizeImgUrl(contributionTokenImage)"
            height="40px"
            width="40px"
            alt=""
            class="mb-1"
          /> -->
          <p>{{ contributionTokenSymbol }}</p>
        </div>
        <div class="col-4 offset-2">
          <div class="input-wrapper">
            <label for="first">You get</label>
            <input type="number" formControlName="payoutValue" value="500" />
          </div>
        </div>
        <div
          class="col-1 d-flex flex-column justify-content-center align-items-top"
        >
          <img
            [src]="sanitizeImgUrl(tokenImage)"
            height="40px"
            width="40px"
            alt=""
          />
          <p>{{ tokenSymbol }}</p>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12 text-center">
          <p class="m-0">You will recieve your tokens on date.</p>
        </div>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button
      nbButton
      status="success"
      fullWidth
      size="small"
      (click)="contribute()"
      [disabled]="contributeForm.invalid"
    >
      BUY
    </button>
  </nb-card-footer>
</nb-card>
